require("core-js/modules/es.promise.finally.js");

function n(n) {
  return n && "object" == typeof n && "default" in n ? n.default : n;
}

var t = require("react"),
    r = n(t),
    e = require("redux"),
    o = n(require("redux-thunk")),
    u = require("immer"),
    i = n(require("memoizerific")),
    c = require("is-plain-object"),
    f = require("use-memo-one"),
    a = t.createContext(),
    s = "undefined" != typeof window ? t.useLayoutEffect : t.useEffect;

function v(n) {
  return function (r, e) {
    var o = t.useContext(n),
        u = t.useRef(r),
        i = t.useRef(),
        c = t.useRef(!0),
        f = t.useRef(),
        a = t.useReducer(function (n) {
      return n + 1;
    }, 0)[1];
    if (f.current || u.current !== r || void 0 === i.current) try {
      i.current = r(o.getState());
    } catch (n) {
      if ("development" === process.env.NODE_ENV) {
        var v = "An error occurred trying to map state in a useStoreState hook: " + n.message + ".";
        throw f.current && (v += "\nThis error may be related to the following error:\n" + f.current.stack + "\n\nOriginal stack trace:"), new Error(v);
      }

      throw f.current || n;
    }
    return s(function () {
      u.current = r, f.current = void 0;
    }), s(function () {
      var n = function n() {
        try {
          var n = u.current(o.getState());
          if ("function" == typeof e ? e(i.current, n) : i.current === n) return;
          i.current = n;
        } catch (n) {
          f.current = n;
        }

        c.current && a({});
      },
          t = o.subscribe(n);

      return n(), function () {
        c.current = !1, t();
      };
    }, []), i.current;
  };
}

var l = v(a);

function d(n) {
  return function (r) {
    return r(t.useContext(n).getActions());
  };
}

var p = d(a);

function y(n) {
  return function () {
    return t.useContext(n).dispatch;
  };
}

var m = y(a);

function h() {
  return t.useContext(a);
}

function S(n) {
  return function () {
    var r = t.useContext(n),
        e = t.useState(!1),
        o = e[0],
        u = e[1];
    return t.useEffect(function () {
      r.persist.resolveRehydration().then(function () {
        return u(!0);
      });
    }, []), o;
  };
}

var g = S(a);

function w() {
  return (w = Object.assign || function (n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var e in r) {
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
      }
    }

    return n;
  }).apply(this, arguments);
}

var b = function b(n) {
  var t;
  return (t = {}).$ep_a = !0, t.fn = n, t;
},
    j = [function (n) {
  return n;
}],
    P = new u.Immer({
  useProxies: !0,
  autoFreeze: !1
}),
    O = function O(n) {
  return function n(t) {
    var r = Object.keys(t).reduce(function (n, r) {
      return null == Object.getOwnPropertyDescriptor(t, r).get && (n[r] = t[r]), n;
    }, {});
    return Object.keys(r).forEach(function (t) {
      c.isPlainObject(r[t]) && (r[t] = n(r[t]));
    }), r;
  }(n);
},
    x = function x(n) {
  return null != n && "object" == typeof n && "function" == typeof n.then;
};

function _(n, t) {
  return n.reduce(function (n, t) {
    return c.isPlainObject(n) ? n[t] : void 0;
  }, t);
}

var A = function A(n, t, r) {
  0 !== n.length ? n.reduce(function (t, e, o) {
    return t[e] = o + 1 === n.length ? r : t[e] || {}, t[e];
  }, t) : "object" == typeof r && (Object.keys(t).forEach(function (n) {
    delete t[n];
  }), Object.keys(r).forEach(function (n) {
    t[n] = r[n];
  }));
},
    k = function k(n) {
  try {
    var t = [];
    return Promise.resolve((r = n, new Promise(function (n, e) {
      var o = r[Symbol.iterator]();
      !function r(u) {
        try {
          var i = o.next();
          if (i.done) return n(u), Promise.resolve();

          var c = function (n, e) {
            try {
              var o = Promise.resolve(Promise.all([u, i.value])).then(function (n) {
                r(function (n, r) {
                  try {
                    return Promise.resolve(r()).then(function (n) {
                      t.push(n);
                    });
                  } catch (n) {
                    return Promise.reject(n);
                  }
                }(0, n[1]));
              });
            } catch (n) {
              return e(n);
            }

            return o && o.then ? o.then(void 0, e) : o;
          }(0, function (n) {
            e(n);
          });

          return Promise.resolve(c && c.then ? c.then(function () {}) : void 0);
        } catch (n) {
          return Promise.reject(n);
        }
      }(void 0);
    }))).then(function () {
      return t;
    });
  } catch (n) {
    return Promise.reject(n);
  }

  var r;
};

function I(n, t, r, e) {
  var o = function (n) {
    return void 0 === n && (n = !1), function (t, r, e) {
      if (n) {
        var o = _(t, r),
            i = e(o);

        return o !== i ? function n(t, r, e) {
          if (0 === t.length) return e;
          var o = w({}, r),
              u = t[0];
          return o[u] = 1 === t.length ? e : n(t.slice(1), o[u], e), o;
        }(t, r, i) : r;
      }

      if (0 === t.length) {
        var c = P.createDraft(r),
            f = e(c);
        return f ? u.isDraft(f) ? P.finishDraft(f) : f : P.finishDraft(c);
      }

      var a = t.slice(0, t.length - 1),
          s = P.createDraft(r),
          v = _(a, r),
          l = e(_(t, s));

      return l && (v[t[t.length - 1]] = l), P.finishDraft(s);
    };
  }(n);

  return function (n, u) {
    var i = function (n, r) {
      var e = t[r.type];
      return e ? function (n, t, r, e) {
        return o(e, n, function (n) {
          return r(n, t.payload);
        });
      }(n, r, e, e.definition.meta.parent) : n;
    }(n, u),
        c = r.length > 0 ? function (n, t) {
      return r.reduce(function (n, r) {
        var e = r.key,
            u = r.reducer;
        return o(r.parentPath, n, function (n) {
          return n[e] = u(n[e], t), n;
        });
      }, n);
    }(i, u) : i;

    return n !== c && e.forEach(function (n) {
      var t = n.bindComputedProperty,
          r = _(n.parentPath, c);

      null != r && t(r, c);
    }), c;
  };
}

var R = {
  getItem: function getItem() {},
  setItem: function setItem() {},
  removeItem: function removeItem() {}
},
    T = function T(n) {
  var t;
  return function () {
    if (!t) {
      try {
        "undefined" != typeof window && void 0 !== window[n] && (t = window[n]);
      } catch (n) {}

      t || (t = R);
    }

    return t;
  };
},
    C = T("localStorage"),
    q = T("sessionStorage");

function D(n, t) {
  void 0 === t && (t = []), null == n && (n = q()), "string" == typeof n && ("localStorage" === n ? n = C() : "sessionStorage" === n ? n = q() : ("development" === process.env.NODE_ENV && console.warn("Invalid storage provider specified for Easy Peasy persist: " + n + '\nValid values include "localStorage", "sessionStorage" or a custom storage engine.'), n = R));

  var r = [].concat(t).reverse(),
      e = function e(t) {
    var e = n === C() || n === q() ? JSON.parse(t).data : t;
    return r.length > 0 && null != e && "object" == typeof e && Object.keys(e).forEach(function (n) {
      e[n] = r.reduce(function (t, r) {
        return r.out(t, n);
      }, e[n]);
    }), e;
  },
      o = x(n.getItem("_"));

  return {
    isAsync: o,
    getItem: function getItem(t) {
      if (o) return n.getItem(t).then(function (n) {
        return null != n ? e(n) : void 0;
      });
      var r = n.getItem(t);
      return null != r ? e(r) : void 0;
    },
    setItem: function setItem(r, e) {
      return n.setItem(r, function (r) {
        return t.length > 0 && null != r && "object" == typeof r && Object.keys(r).forEach(function (n) {
          r[n] = t.reduce(function (t, r) {
            return r.in(t, n);
          }, r[n]);
        }), n === C() || n === q() ? JSON.stringify({
          data: r
        }) : r;
      }(e));
    },
    removeItem: function removeItem(t) {
      return n.removeItem(t);
    }
  };
}

function M(n, t) {
  return function () {
    return 0 === t.internals.t.length ? Promise.resolve() : k(t.internals.t.map(function (t) {
      var r = t.path,
          e = t.config;
      return function () {
        return Promise.resolve(e.storage.removeItem(n(r)));
      };
    }));
  };
}

function E(n, t, r, e) {
  return 0 === r.internals.t.length ? Promise.resolve() : k(r.internals.t.map(function (o) {
    return function () {
      var u = o.path,
          i = o.config,
          f = i.mergeStrategy,
          a = i.storage;
      if (e && (u.length < 1 || u[0] !== e)) return Promise.resolve();

      var s = r.internals.o,
          v = function v(n, t) {
        return null != n && null != t && (typeof n != typeof t || Array.isArray(n) && !Array.isArray(t));
      },
          l = function l(n) {
        null != n && function (n, t) {
          if ("overwrite" === f) A(u, n, t);else if ("mergeShallow" === f) {
            var r = _(u, n);

            Object.keys(t).forEach(function (n) {
              v(r[n], t[n]) || (r[n] = t[n]);
            });
          } else "mergeDeep" === f && function n(t, r) {
            Object.keys(r).forEach(function (e) {
              v(t[e], r[e]) || (c.isPlainObject(r[e]) ? (t[e] = t[e] || {}, n(t[e], r[e])) : t[e] = r[e]);
            });
          }(_(u, n), t);
        }(s, n), t(s);
      },
          d = a.getItem(n(u));

      return x(d) ? d.then(l) : Promise.resolve(l(d));
    };
  }));
}

var N = function N(n, t) {
  console.log("An error occurred in a listener for " + n), console.log(t);
},
    z = function z(n, t) {
  return function () {
    try {
      var r = t.apply(void 0, [].slice.call(arguments));
      x(r) && r.catch(function (t) {
        N(n, t);
      });
    } catch (t) {
      N(n, t);
    }
  };
};

function J(n) {
  return function () {
    return function (t) {
      return function (r) {
        var e = t(r);

        if (r && n.internals.u[r.type] && n.internals.u[r.type].length > 0) {
          var o = n.internals.i[r.type];
          n.internals.u[r.type].forEach(function (n) {
            n({
              type: o ? o.definition.meta.type : r.type,
              payload: r.payload,
              error: r.error,
              result: r.result
            });
          });
        }

        return e;
      };
    };
  };
}

function F(n) {
  return function (t) {
    return function (r) {
      return function (e) {
        return n.internals.s.currentState = t.getState(), n.internals.s.isInReducer = !0, r(e);
      };
    };
  };
}

function L(n) {
  return function (t) {
    return function (r) {
      return function (e) {
        if (0 === n.internals.v.length) return r(e);
        var o = t.getState(),
            u = r(e),
            i = t.getState();
        return n.internals.v.forEach(function (n) {
          var t = _(n.meta.parent, o),
              r = _(n.meta.parent, i);

          if (t !== r) {
            var u = n.dependencyResolvers.map(function (n) {
              return n(t);
            }),
                c = n.dependencyResolvers.map(function (n) {
              return n(r);
            });
            u.some(function (n, t) {
              return n !== c[t];
            }) && n.actionCreator(u, c, e);
          }
        }), u;
      };
    };
  };
}

var V = function V(n) {
  console.log(n);
},
    Y = function Y(n, t) {
  console.log("An error occurred in a listener for " + n), console.log(t);
},
    $ = function $(n, t) {
  return function () {
    try {
      var r = t.apply(void 0, [].slice.call(arguments));
      x(r) && r.catch(function (t) {
        Y(n, t);
      });
    } catch (t) {
      Y(n, t);
    }
  };
};

function B(n, t) {
  void 0 === t && (t = {});
  var r = O(n),
      u = t.compose,
      f = t.devTools,
      a = void 0 === f ? "production" !== process.env.NODE_ENV : f,
      s = t.disableImmer,
      v = void 0 !== s && s,
      l = t.enhancers,
      d = void 0 === l ? [] : l,
      p = t.initialState,
      y = void 0 === p ? {} : p,
      m = t.injections,
      h = void 0 === m ? {} : m,
      S = t.middleware,
      g = void 0 === S ? [] : S,
      j = t.mockActions,
      P = void 0 !== j && j,
      R = t.name,
      T = void 0 === R ? "EasyPeasyStore" : R,
      C = t.version,
      q = void 0 === C ? 0 : C,
      N = t.reducerEnhancer,
      Y = void 0 === N ? function (n) {
    return n;
  } : N;
  if ("production" !== process.env.NODE_ENV && "object" != typeof h) throw new Error("[easy-peasy] Store injections must be an object");

  var B = function B(n) {
    return w({}, n, {
      ePRS: b(function (n, t) {
        return t;
      })
    });
  },
      G = {},
      H = B(r),
      K = [],
      Q = function Q(n) {
    return "[" + T + "][" + q + "]" + (n.length > 0 ? "[" + n.join(".") + "]" : "");
  },
      U = function (n, t) {
    var r,
        e = Promise.resolve(),
        o = !1,
        u = "undefined" == typeof window ? function (n) {
      return n();
    } : null != window.requestIdleCallback ? window.requestIdleCallback : window.requestAnimationFrame;
    return {
      persist: function persist(i) {
        if (0 !== t.internals.t.length) {
          var f = function f() {
            o = !0, e = new Promise(function (e) {
              u(function () {
                k(t.internals.t.map(function (t) {
                  var r = t.path,
                      e = t.config;
                  return function () {
                    var t = e.storage,
                        o = e.allow,
                        u = e.deny,
                        f = function (n, t, r) {
                      var e = Object.keys(n);
                      return t.length > 0 && (e = e.reduce(function (n, r) {
                        return -1 !== t.findIndex(function (n) {
                          return n === r;
                        }) ? [].concat(n, [r]) : n;
                      }, [])), r.length > 0 && (e = e.reduce(function (n, t) {
                        return -1 !== r.findIndex(function (n) {
                          return n === t;
                        }) ? n : [].concat(n, [t]);
                      }, [])), e;
                    }(O(_(r, i)), o, u),
                        a = {};

                    return f.map(function (n) {
                      var t = _([].concat(r, [n]), i),
                          e = c.isPlainObject(t) ? O(t) : t;

                      a[n] = e;
                    }), Promise.resolve(t.setItem(n(r), a));
                  };
                })).finally(function () {
                  if (o = !1, r) {
                    var n = r;
                    r = null, n();
                  } else e();
                });
              });
            });
          };

          o ? r = f : f();
        }
      },
      clear: M(n, t),
      flush: function flush() {
        try {
          return r && r(), Promise.resolve(e).then(function () {});
        } catch (n) {
          return Promise.reject(n);
        }
      }
    };
  }(Q, G),
      W = function (n, t) {
    return function (r) {
      var e = r.getState;
      return function (r) {
        return function (o) {
          var u = r(o);
          return o && "@action.ePRS" !== o.type && t.internals.t.length > 0 && n.persist(e()), u;
        };
      };
    };
  }(U, G),
      X = function X(n) {
    return G.internals.i["@action.ePRS"](n);
  },
      Z = function Z(n) {
    void 0 === n && (n = {}), G.internals = function (n) {
      var t = n.disableImmer,
          r = n.reducerEnhancer,
          e = function (n, t, r, e) {
        var o = t,
            u = {},
            f = {},
            a = {},
            s = {},
            v = [],
            l = [],
            d = [],
            p = {},
            y = {},
            m = [],
            h = [],
            S = {
          isInReducer: !1,
          currentState: o
        };
        return h = h.sort(function (n, t) {
          var r = n.path.join("."),
              e = t.path.join(".");
          return r < e ? -1 : r > e ? 1 : 0;
        }), function n(y, S) {
          return Object.keys(y).forEach(function (g) {
            var b = y[g],
                j = [].concat(S, [g]),
                P = {
              parent: S,
              path: j,
              key: g
            },
                O = function O() {
              var n = _(S, t);

              A(j, o, n && g in n ? n[g] : b);
            };

            if ("$ep_p" !== g) {
              if (null != b && "object" == typeof b) {
                if (b.$ep_a || b.$ep_aO) {
                  var k = w({}, b),
                      I = k.$ep_a ? "@action" : "@actionOn";
                  k.meta = {
                    actionName: P.key,
                    category: I,
                    type: I + "." + P.path.join("."),
                    parent: P.parent,
                    path: P.path
                  }, k.actionCreator = function (n, t) {
                    var r = function r(_r) {
                      var e = {
                        type: n.meta.type,
                        payload: _r
                      };
                      return n.$ep_aO && n.meta.resolvedTargets && (_r.resolvedTargets = [].concat(n.meta.resolvedTargets)), t.dispatch(e);
                    };

                    return r.type = n.meta.type, r;
                  }(k, e), k.actionCreator.definition = k, k.fn.definition = k, u[k.meta.type] = k.actionCreator, a[k.meta.type] = k.fn, "ePRS" !== P.key && (k.$ep_aO ? (m.push(k), A(j, p, k.actionCreator)) : A(j, f, k.actionCreator));
                } else if (b.$ep_t || b.$ep_tO) {
                  var R = w({}, b),
                      T = (R.$ep_t ? "@thunk" : "@thunkOn") + "." + P.path.join(".");
                  R.meta = {
                    actionName: P.key,
                    parent: P.parent,
                    path: P.path,
                    type: T,
                    startType: T + "(start)",
                    successType: T + "(success)",
                    failType: T + "(fail)"
                  }, R.thunkHandler = function (n, t, r, e) {
                    return function (o, u) {
                      var i = {
                        dispatch: t.dispatch,
                        fail: u,
                        getState: function getState() {
                          return _(n.meta.parent, t.getState());
                        },
                        getStoreActions: function getStoreActions() {
                          return e;
                        },
                        getStoreState: t.getState,
                        injections: r,
                        meta: {
                          key: n.meta.actionName,
                          parent: n.meta.parent,
                          path: n.meta.path
                        }
                      };
                      return n.$ep_tO && n.meta.resolvedTargets && (o.resolvedTargets = [].concat(n.meta.resolvedTargets)), n.fn(_(n.meta.parent, e), o, i);
                    };
                  }(R, e, r, f), A(j, s, R.thunkHandler), R.actionCreator = function (n, t) {
                    var r = function r(_r2) {
                      var e = z(n.meta.startType, function () {
                        return t.dispatch({
                          type: n.meta.startType,
                          payload: _r2
                        });
                      }),
                          o = z(n.meta.failType, function (e) {
                        return t.dispatch({
                          type: n.meta.failType,
                          payload: _r2,
                          error: e
                        });
                      }),
                          u = z(n.meta.successType, function (e) {
                        return t.dispatch({
                          type: n.meta.successType,
                          payload: _r2,
                          result: e
                        });
                      });
                      e();

                      var i = null,
                          c = function c(n) {
                        i = n;
                      },
                          f = t.dispatch(function () {
                        return n.thunkHandler(_r2, c);
                      });

                      return x(f) ? f.then(function (n) {
                        return i ? o(i) : u(n), n;
                      }) : (i ? o(i) : u(f), f);
                    };

                    return r.type = n.meta.type, r.successType = n.meta.successType, r.failType = n.meta.failType, r.startType = n.meta.startType, r;
                  }(R, e), R.actionCreator.definition = R, u[R.meta.type] = R.actionCreator, R.$ep_tO ? (m.push(R), A(j, p, R.actionCreator)) : A(j, f, R.actionCreator);
                } else if (b.$ep_c) {
                  var C = _(S, o),
                      q = function (n, t, r, e, o) {
                    var u = i(1)(r.fn);
                    return function (e, o) {
                      Object.defineProperty(e, t, {
                        configurable: !0,
                        enumerable: !0,
                        get: function get() {
                          var t = _(n, o),
                              e = r.stateResolvers.map(function (n) {
                            return n(t, o);
                          });

                          return u.apply(void 0, e);
                        }
                      });
                    };
                  }(S, g, b);

                  q(C, o), v.push({
                    key: g,
                    parentPath: S,
                    bindComputedProperty: q
                  });
                } else if (b.$ep_r) l.push({
                  key: g,
                  parentPath: S,
                  reducer: b.fn
                });else if (b.$ep_e) {
                  var M = w({}, b),
                      E = "@effectOn." + P.path.join(".");
                  M.meta = {
                    type: E,
                    actionName: P.key,
                    parent: P.parent,
                    path: P.path,
                    startType: E + "(start)",
                    successType: E + "(success)",
                    failType: E + "(fail)"
                  };

                  var N = function (n, t, r, e) {
                    var o,
                        u = _(n.meta.parent, e);

                    return function (i) {
                      var c = {
                        dispatch: t.dispatch,
                        getState: function getState() {
                          return _(n.meta.parent, t.getState());
                        },
                        getStoreActions: function getStoreActions() {
                          return e;
                        },
                        getStoreState: t.getState,
                        injections: r,
                        meta: {
                          key: n.meta.actionName,
                          parent: n.meta.parent,
                          path: n.meta.path
                        }
                      };

                      if (void 0 !== o) {
                        var f = o();
                        o = void 0, x(f) && f.catch(V);
                      }

                      var a = n.fn(u, i, c);
                      if (x(a)) return a.then(function (n) {
                        "function" == typeof n && "production" !== process.env.NODE_ENV && console.warn("[easy-peasy] You have an effect which is asynchronously resolving a dispose function. This is considered an anti-pattern. Please read the API documentation for more information.");
                      });
                      "function" == typeof a && (o = a);
                    };
                  }(M, e, r, f),
                      J = function (n, t, r) {
                    var e = function e(_e, o, u) {
                      var i = {
                        prev: _e,
                        current: o,
                        action: u
                      },
                          c = $(n.meta.startType, function () {
                        return t.dispatch({
                          type: n.meta.startType,
                          change: i
                        });
                      }),
                          f = $(n.meta.successType, function () {
                        return t.dispatch({
                          type: n.meta.successType,
                          change: i
                        });
                      });
                      c();

                      try {
                        var a = t.dispatch(function () {
                          return r(i);
                        });
                        return x(a) ? a.then(function (n) {
                          return f(n), n;
                        }, V) : (f(a), a);
                      } catch (n) {
                        V(n);
                      }
                    };

                    return e.type = n.meta.type, e.startType = n.meta.startType, e.successType = n.meta.successType, e.failType = n.meta.failType, e;
                  }(M, e, N);

                  M.actionCreator = J, d.push(M);
                } else c.isPlainObject(b) ? (null == _(j, o) && A(j, o, {}), n(b, j)) : O();
              } else O();
            } else h.push(function (n, t) {
              return void 0 === t && (t = {}), {
                path: n,
                config: {
                  allow: t.allow || [],
                  deny: t.deny || [],
                  mergeStrategy: t.mergeStrategy || "mergeDeep",
                  storage: D(t.storage, t.transformers)
                }
              };
            }(S, b));
          });
        }(n, []), function (n, t, r, e) {
          n.forEach(function (n) {
            var o = n.targetResolver(_(n.meta.parent, t), t),
                u = (Array.isArray(o) ? o : [o]).reduce(function (n, t) {
              return "function" == typeof t && t.definition.meta.type && r[t.definition.meta.type] ? n.push(t.definition.meta.successType ? t.definition.meta.successType : t.definition.meta.type) : "string" == typeof t && n.push(t), n;
            }, []);
            n.meta.resolvedTargets = u, u.forEach(function (t) {
              var o = e[t] || [];
              o.push(r[n.meta.type]), e[t] = o;
            });
          });
        }(m, f, u, y), {
          i: u,
          l: f,
          p: a,
          m: v,
          h: l,
          s: S,
          o: o,
          v: d,
          S: p,
          u: y,
          t: h
        };
      }(n.model, n.initialState, n.injections, n.references),
          o = e.m;

      return {
        i: e.i,
        l: e.l,
        m: o,
        s: e.s,
        o: e.o,
        v: e.v,
        S: e.S,
        u: e.u,
        t: e.t,
        reducer: r(I(t, e.p, e.h, o))
      };
    }({
      disableImmer: v,
      initialState: n,
      injections: h,
      model: H,
      reducerEnhancer: Y,
      references: G
    });
  },
      nn = u || (a && "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: T
  }) : e.compose);

  Z(y);
  var tn = [F(G)].concat(g, [o, J(G), L(G), W]);
  P && tn.push(function () {
    return function () {
      return function (n) {
        null != n && K.push(n);
      };
    };
  });
  var rn = e.createStore(G.internals.reducer, G.internals.o, nn.apply(void 0, [e.applyMiddleware.apply(void 0, tn)].concat(d)));
  rn.subscribe(function () {
    G.internals.s.isInReducer = !1;
  }), G.dispatch = rn.dispatch, G.getState = rn.getState;

  var en = function en() {
    Object.keys(rn.dispatch).forEach(function (n) {
      delete rn.dispatch[n];
    }), Object.keys(G.internals.l).forEach(function (n) {
      rn.dispatch[n] = G.internals.l[n];
    });
  };

  en();

  var on = function on(n) {
    var t = rn.getState();
    n && delete t[n], Z(t), rn.replaceReducer(G.internals.reducer), X(G.internals.o), en();
  },
      un = E(Q, X, G);

  return Object.assign(rn, {
    addModel: function addModel(n, t) {
      H[n] && "production" !== process.env.NODE_ENV && (console.warn('easy-peasy: The store model already contains a model definition for "' + n + '"'), rn.removeModel(n)), H[n] = t, on();
      var r = E(Q, X, G, n);
      return {
        resolveRehydration: function resolveRehydration() {
          return r;
        }
      };
    },
    clearMockedActions: function clearMockedActions() {
      K = [];
    },
    getActions: function getActions() {
      return G.internals.l;
    },
    getListeners: function getListeners() {
      return G.internals.S;
    },
    getMockedActions: function getMockedActions() {
      return [].concat(K);
    },
    persist: {
      clear: U.clear,
      flush: U.flush,
      resolveRehydration: function resolveRehydration() {
        return un;
      }
    },
    reconfigure: function reconfigure(n) {
      H = B(n), on();
    },
    removeModel: function removeModel(n) {
      H[n] ? (delete H[n], on(n)) : "production" !== process.env.NODE_ENV && console.warn('easy-peasy: The store model does not contain a model definition for "' + n + '"');
    }
  });
}

exports.StoreProvider = function (n) {
  return r.createElement(a.Provider, {
    value: n.store
  }, n.children);
}, exports.action = b, exports.actionOn = function (n, t) {
  var r;
  return (r = {}).$ep_aO = !0, r.fn = t, r.targetResolver = n, r;
}, exports.computed = function (n, t) {
  var r, e;
  return "function" == typeof t ? ((e = {}).$ep_c = !0, e.fn = t, e.stateResolvers = n, e) : ((r = {}).$ep_c = !0, r.fn = n, r.stateResolvers = j, r);
}, exports.createContextStore = function (n, e) {
  void 0 === e && (e = {});
  var o = e.injections,
      u = void 0 === o ? {} : o,
      i = t.createContext();
  return {
    Provider: function Provider(t) {
      var o = t.children,
          c = t.runtimeModel,
          a = t.injections;

      if (null != a) {
        var s = "function" == typeof a ? a(u) : a,
            v = Object.keys(s);
        Object.keys(u).filter(function (n) {
          return !v.includes(n);
        }).forEach(function (n) {
          delete u[n];
        }), Object.assign(u, s);
      }

      var l = f.useMemoOne(function () {
        return B("function" == typeof n ? n(c) : n, w({}, e, {
          originalInjections: u
        }));
      }, []);
      return r.createElement(i.Provider, {
        value: l
      }, o);
    },
    useStore: function useStore() {
      return t.useContext(i);
    },
    useStoreState: v(i),
    useStoreActions: d(i),
    useStoreDispatch: y(i),
    useStoreRehydrated: S(i)
  };
}, exports.createStore = B, exports.createTransform = function (n, t, r) {
  void 0 === r && (r = {});
  var e = r.whitelist || null,
      o = r.blacklist || null;

  function u(n) {
    return !(!e || -1 !== e.indexOf(n)) || !(!o || -1 === o.indexOf(n));
  }

  return {
    in: function _in(t, r, e) {
      return !u(r) && n ? n(t, r, e) : t;
    },
    out: function out(n, r, e) {
      return !u(r) && t ? t(n, r, e) : n;
    }
  };
}, exports.createTypedHooks = function () {
  return {
    useStoreActions: p,
    useStoreDispatch: m,
    useStoreState: l,
    useStoreRehydrated: g,
    useStore: h
  };
}, exports.debug = function (n) {
  return u.isDraft(n) ? u.current(n) : n;
}, exports.generic = function (n) {
  return n;
}, exports.memo = function (n, t) {
  return i(t)(n);
}, exports.persist = function (n, t) {
  var r;
  return "undefined" == typeof window ? n : w({}, n, ((r = {}).$ep_p = t, r));
}, exports.reducer = function (n) {
  var t;
  return (t = {}).$ep_r = !0, t.fn = n, t;
}, exports.thunk = function (n) {
  var t;
  return (t = {}).$ep_t = !0, t.fn = n, t;
}, exports.thunkOn = function (n, t) {
  var r;
  return (r = {}).$ep_tO = !0, r.fn = t, r.targetResolver = n, r;
}, exports.unstable_effectOn = function (n, t) {
  var r;
  return (r = {}).$ep_e = !0, r.dependencyResolvers = n, r.fn = t, r;
}, exports.useLocalStore = function (n, r, e) {
  void 0 === r && (r = []);
  var o = t.useRef(),
      u = t.useRef(),
      i = f.useMemoOne(function () {
    var t = null != o.current ? o.current.getState() : void 0,
        r = null != e ? e(t, u.current) : void 0,
        i = B(n(t), r);
    return u.current = r, o.current = i, i;
  }, r),
      c = t.useState(function () {
    return i.getState();
  }),
      a = c[0],
      s = c[1];
  return t.useEffect(function () {
    return i.subscribe(function () {
      var n = i.getState();
      a !== n && s(n);
    });
  }, [i]), [a, i.getActions(), i];
}, exports.useStore = h, exports.useStoreActions = p, exports.useStoreDispatch = m, exports.useStoreRehydrated = g, exports.useStoreState = l;